module Meevo.Plugins.AppointmentBook {
    export class AppointmentNoteService {
        static $inject = [
            "restServer",
            "appointmentBookHelperService",
            "appointmentBookActionsService",
            "$rootScope",
            "appointmentBookGlobalsService",
            'meevo.components.common.DataService',
            '$q'
        ];

        noteTypes: any;

        constructor(
            private restServer: any,
            private helper: any,
            private actions: any,
            rootScope: any,
            private globals,
            private dataService,
            private $q) {

        }

        setNoteTypes(): any {
            this.noteTypes = [
                {
                    displayName: '',
                    id: Meevo.Model.AppointNoteTypeEnum.AppointmentBookOnly
                },
                {
                    displayName: "Check in",
                    id: Meevo.Model.AppointNoteTypeEnum.Checkin
                }
            ];

            if (!this.globals.businessInfo) {
                this.restServer.LoadBusinessInfoSettings().then((response) => {
                    additionalNoteTypes(response.data.registerSettings, this.noteTypes);
                });
            } else {
                additionalNoteTypes(this.globals.businessInfo.enableIntegratedRegister, this.noteTypes);
            }

            function additionalNoteTypes(enableIntegratedRegister, noteTypes) {
                if (enableIntegratedRegister) {
                    noteTypes.push({
                        displayName: "Register",
                        id: Meevo.Model.AppointNoteTypeEnum.Register
                    });
                    noteTypes.push({
                        displayName: "Chk/Reg",
                        id: Meevo.Model.AppointNoteTypeEnum.CheckinRegister
                    });
                }
            }
        }
    }
}
angular.module("ApptBookApp")
    .service("meevo.plugins.appointmentBook.AppointmentNoteService", Meevo.Plugins.AppointmentBook.AppointmentNoteService);